module.exports = __webpack_public_path__ + "img/p3.b03549d9.png";